import { Navigate, useParams } from "react-router-dom";
import { Check } from "lucide-react";
import { SERVICE_PAGES } from "@/components/site/seoData";
import { PageHero } from "@/components/site/PageHero";
import { CityLinks, ServiceLinks } from "@/components/site/SeoLinks";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Quote } from "@/components/site/Quote";
import { Eyebrow, Reveal } from "@/components/site/Reveal";
import { Seo } from "@/components/site/Seo";

export default function ServicePage() {
  const { slug } = useParams();
  const s = SERVICE_PAGES.find((x) => x.slug === slug);
  if (!s) return <Navigate to="/" replace />;
  return (
    <>
      <Seo title={s.title} description={s.desc} path={`/services/${s.slug}`} />
      <PageHero eyebrow="Cazares Junk Removal · Greenville SC" title={s.name} accent="in Greenville, SC" intro={s.intro} crumbs={["Services", s.name]} />
      <section className="bg-[#F2EEE6] py-20 sm:py-28">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 lg:grid-cols-12">
          <Reveal className="lg:col-span-5">
            <Eyebrow dark>What we take</Eyebrow>
            <h2 className="font-display mt-4 text-5xl uppercase leading-[0.9] text-[#0D0D0B] sm:text-7xl">{s.name} we handle</h2>
            <p className="mt-5 text-base text-[#3a3a35] sm:text-lg">Not sure if your item qualifies? Call {`(864) 518-1871`} and ask. We give you a free onsite quote and an upfront price before anything gets loaded.</p>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-7">
            <ul data-testid="service-items-list" className="grid gap-3 sm:grid-cols-2">
              {s.items.map((it) => (
                <li key={it} className="flex items-center gap-3 rounded-2xl bg-white px-5 py-4 text-lg font-bold text-[#0D0D0B]">
                  <span className="grid h-8 w-8 shrink-0 place-items-center rounded-full bg-[#FFB000]"><Check className="h-4 w-4" strokeWidth={3} /></span>{it}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </section>
      <HowItWorks />
      <section className="bg-[#0D0D0B] pb-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <h2 className="font-display text-4xl uppercase text-[#F2EEE6] sm:text-5xl">{s.name} near you</h2>
          <p className="mb-6 mt-3 max-w-2xl text-[#d6d2c8]">We offer {s.name.toLowerCase()} in Greenville, South Carolina and nearby Upstate communities:</p>
          <CityLinks />
          <h2 className="font-display mb-6 mt-16 text-4xl uppercase text-[#F2EEE6] sm:text-5xl">Other junk removal services</h2>
          <ServiceLinks exclude={s.slug} dark />
        </div>
      </section>
      <Quote defaultService={s.option} />
    </>
  );
}
